export default __webpack_public_path__ + "static/media/glow.be11ef19.png";